import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { Content } from '../../infrastructure/content';
import PropTypes from '../../types';

const IDVChallengeErrorPage = ({ bankId, username }) => (
  <div>
    <Content>
      {({
        idvChallengeErrorHeading,
        idvChallengeErrorSubHeading,
        deferredContent3,
        deferredContent4,
        deferredContent5,
        deferredContent6,
        deferredContent7,
        deferredContent8
      }) => (
        <StandardBody>
          <PageHeading>{idvChallengeErrorHeading}</PageHeading>
          <p>{idvChallengeErrorSubHeading}</p>
          <StandoutTile.Remember>
            <p>{deferredContent3}</p>
            <BulletList
              items={[deferredContent4, deferredContent5, deferredContent6, deferredContent7]}
            />
            <p>
              <b>
                {deferredContent8} {username}
              </b>
            </p>
          </StandoutTile.Remember>
        </StandardBody>
      )}
    </Content>
  </div>
);

IDVChallengeErrorPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default IDVChallengeErrorPage;
